<template>
  <div class="relative">
    <MsgBanner
      class="top-banner"
      @bannerTriggered="getBannerAvailability"
    />
    <!-- <Alert /> -->
    <!-- <div
      style="z-index:10"
      class="snow-animation"
    >
      <Snow />
    </div> -->
    <layout-vertical>
      <router-view :key="$route.fullPath" />

      <template #navbar="{ toggleVerticalMenuActive }">
        <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
      </template>

      <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
    </layout-vertical>
  </div>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
// import Snow from '@/components/Snow/Snow.vue'
import RouteOptimizationRepository from '@/repository/routeOptimizationRepository'
import { tenant } from '@/constants/config'
import Cookies from 'js-cookie'
import Navbar from '../components/Navbar.vue'
// import Alert from '../../components/Notification/Alert.vue'
import MsgBanner from '../../components/Notification/msg_banner.vue'

export default {
  components: {
    // AppCustomizer,
    LayoutVertical,
    // eslint-disable-next-line vue/no-unused-components
    Navbar,
    // Alert,
    // Snow,
    MsgBanner,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },
  methods: {
    async onRouteOptimizationClick() {
      const dialogText = 'Are you certain about redirecting to Route Optimization?'
      const result = await this.$swal({
        title: 'Are you sure?',
        text: dialogText,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes, confirm!',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        backdrop: 'modal-no-backdrop',
      })
      if (result.isConfirmed) {
        await this.redirectToRouteOpt()
      }
    },
    getRootDomain() {
      const host = window.location.hostname

      if (host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
        return undefined
      }

      const parts = host.split('.')
      return `.${parts.slice(-2).join('.')}`
    },
    getRouteOptimizationTenantId(clientId) {
      const match = clientId && clientId.match(/^tenant-([^-]+)-/)
      return match ? match[1] : process.env.VUE_APP_ROUTE_X_Tenant
    },
    async redirectToRouteOpt() {
      try {
        const clientId = process.env.VUE_APP_ROUTE_OPTIMIZATION_CLIENT_ID
        const clientSecret = process.env.VUE_APP_ROUTE_OPTIMIZATION_CLIENT_SECRET
        const tenantId = this.getRouteOptimizationTenantId(clientId)
        const externalAccessToken = this.$cookies.get('current_user_token')
        const externalTenantId = tenant
        const currentUser = JSON.parse(localStorage.getItem('current_user'))

        const payload = {
          client_id: clientId,
          client_secret: clientSecret,
          tenant_id: tenantId,
          external_access_token: externalAccessToken,
          external_tenant_id: externalTenantId,
          current_user: currentUser,
        }
        const res = await RouteOptimizationRepository.exchangeToken(payload)
        if (res.data && res.data.success) {
          const host = window.location.hostname
          const isLocal = host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)

          const cookieOptions = {
            expires: 1,
            path: '/',
            sameSite: isLocal ? 'Lax' : 'None',
            secure: !isLocal,
          }

          if (!isLocal) {
            cookieOptions.domain = this.getRootDomain()
          }
          Cookies.set('routeOptAuth', JSON.stringify(res.data), cookieOptions)
          window.open(process.env.VUE_APP_ROUTE_OPTIMIZATION, '_blank')
        } else if (this.$bvToast) {
          const message = (res.data && res.data.message) || 'Token exchange failed'
          this.$bvToast.toast(message, { variant: 'danger' })
        }
      } catch (e) {
        if (this.$bvToast) {
          const message = (e.response && e.response.data && e.response.data.message) || 'Token exchange failed'
          this.$bvToast.toast(message, { variant: 'danger' })
        }
      }
    },
  },
}
</script>
<style>
@media print {
  /* Global Styles */

  /* Exclude snow animation from print */
  .snow-animation {
    display: none !important;
  }
  /* Exclude top banner from print */
  .top-banner {
    display: none !important;
  }
  /* Rest of your existing print styles */
}
</style>
